import { FC } from 'react';
import { Heading, Text } from '@livechat/design-system-react-components';

import { Logo } from 'components/logo/Logo';
import Amplitude from 'services/Amplitude';
import { Product } from 'types/product';

import { pushExternalRedirectToDataLayer } from 'helpers/tracking';
import * as styles from './styles';

type Props = {
  productName: string;
  description: string;
  product?: Product;
  imgUrl?: string;
  link?: string;
};

export const LogoutProductCard: FC<Props> = ({
  productName,
  description,
  imgUrl,
  link,
  product,
}) => {
  const handleTrackingEvents = () => {
    pushExternalRedirectToDataLayer(link);
    Amplitude.logEvent(null, 'LOG_OUT_PRODUCT_LINK_CLICK', {
      product: productName,
    });
  };

  return (
    <a
      css={styles.cardLinkStyles}
      href={link}
      rel="noopener noreferrer"
      target="_blank"
      onClick={handleTrackingEvents}
      data-testid={`logout-product-card-${productName.replace(/ /g, '-')}`}
    >
      <div css={styles.cardContainerStyles}>
        <div css={styles.cardImageContainerStyles}>
          {imgUrl && (
            <img
              css={styles.cardImageStyles(productName)}
              src={imgUrl}
              alt={`${productName} logo`}
            />
          )}
          {!!product && <Logo product={product} size="xlarge" />}
        </div>
        <div>
          <Heading size="xs" css={styles.cardProductNameStyles}>
            {productName}
          </Heading>
          <Text size="sm" css={styles.cardDescriptionStyles}>
            {description}
          </Text>
        </div>
      </div>
    </a>
  );
};
